<script lang="ts">
    export let dismiss: (() => void | undefined);
</script>

<div class="modal" on:click|self={() => dismiss?.()}>
    <div class="modalcontent ui segment">
        <slot></slot>
    </div>
</div>

<style>
    .modal
    {
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        padding: 1rem;
        box-sizing: border-box;
    }

    .modalcontent {
        background: white;
        border-radius: 8px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
        max-width: 70%;
        max-height: 90vh;
        overflow-y: auto;
        position: relative;
        animation: modalSlideIn 0.3s ease-out;
        margin-top: 60px; /* Add margin to avoid top bar */
    }

    @keyframes modalSlideIn {
        from {
            opacity: 0;
            transform: translateY(-20px) scale(0.95);
        }
        to {
            opacity: 1;
            transform: translateY(0) scale(1);
        }
    }

    /* Mobile responsive styles */
    @media (max-width: 768px) {
        .modal {
            padding: 0.5rem;
            align-items: flex-start;
            padding-top: 4rem; /* Increase top padding to avoid header */
        }

        .modalcontent {
            max-width: 85%;
            max-height: 80vh; /* Reduce height to ensure it fits */
            width: 100%;
            margin: 0;
            border-radius: 6px;
            margin-top: 0; /* Remove margin on mobile since we use padding-top */
        }
    }

    @media (max-width: 480px) {
        .modal {
            padding: 0.25rem;
            padding-top: 3rem; /* Adjust for smaller screens */
        }

        .modalcontent {
            max-width: 90%;
            max-height: 85vh;
            border-radius: 4px;
        }
    }

    /* Tablet styles */
    @media (min-width: 769px) and (max-width: 1024px) {
        .modal {
            padding: 1.5rem;
        }

        .modalcontent {
            max-width: 75%;
            max-height: 85vh;
        }
    }

    /* Desktop styles */
    @media (min-width: 1025px) {
        .modalcontent {
            max-width: 600px;
            max-height: 80vh;
        }
    }

    /* Improve scrollbar for modal content */
    .modalcontent::-webkit-scrollbar {
        width: 6px;
    }

    .modalcontent::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
    }

    .modalcontent::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
    }

    .modalcontent::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
    }
</style>